import { ref, watchEffect } from 'vue'
import { isFeatureEnabled } from '@/common/services/FeatureFlagService'
import { useApplicationStore } from '@/common/stores/applicationStore'
import { FeatureFlagName } from '@/common/types/featureFlag'

const isClarityInitialized = ref<boolean>(false)

export const useMicrosoftClarity = () => {
  const applicationStore = useApplicationStore()

  if (isClarityInitialized.value) {
    throw new Error('Microsoft Clarity already initialized. Please do not call useMicrosoftClarity multiple times.')
  }

  const initMicrosoftClarity = async () => {
    const isMicrosoftClarityEnable = isFeatureEnabled(FeatureFlagName.MICROSOFT_CLARITY)
    const isEnabled = import.meta.env.PROD && isMicrosoftClarityEnable
    if (!isEnabled) return

    const projectId = __MICROSOFT_CLARITY_PROJECT_ID__

    try {
      const Clarity = (await import('@microsoft/clarity')).default
      Clarity.init(projectId)
      isClarityInitialized.value = true
      unwatch()
    } catch (error) {
      console.error('Failed to initialize Microsoft Clarity:', error)
    }
  }

  const unwatch = watchEffect(() => {
    if (applicationStore.ready) {
      initMicrosoftClarity()
    }
  })
}
